import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.manage-application.user-provisioning', {
        url: '/user-provisioning',
        component: 'companyManageApplicationUserProvisioning',
        resolve: {
            configurationOverviewDTO,
        },
    });
}

/** @ngInject */
function configurationOverviewDTO(appId, companyId, UserProvisioningService) {
    return UserProvisioningService.provisioningConfiguration.get({appId, companyId}).$promise
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/o365-provisioning/o365-provisioning.state.js